<cmx-loader *ngIf="(internalLoader || loader || !isLayoutRendered) && !(loadingOverlayService.visible$ | async)"></cmx-loader>
<cmx-layout-container
  (mobile)="onMobileChange($event)"
  [direction]="direction"
  (logoClick)="onLogoClick()"
  [language]="languageSelector"
  [languages]="languages | async"
  [activeLanguageId]="languageActive | async"
  [languageLabel]="'views.header.lbl_language' | translate"
  [languageMobileLabel]="'views.header.lbl_language' | translate"
  (languageChange)="onLanguageChange($event)"
  [userInitials]="userInitials"
  [userEmail]="userEmail"
  [userName]="userName"
  (userClick)="onUserClick()"
  [legalEntity]="true"
  [legalEntityList]="legalEntityList | async"
  [legalEntityMessage]="legalEntityMessage | async"
  [legalEntityLoading]="legalEntityLooader | async"
  [legalEntityActive]="legalEntityActive | async"
  [legalEntityPlaceholder]="'views.sidebar.lbl_search' | translate"
  [legalEntityMobileLabel]="'views.sidebar.customer.header' | translate"
  (legalEntityChange)="onLegalEntityChange($event)"
  (legalEntitySearchChange)="onLegalEntitySearch($event)"
  (legalEntityReachedEnd)="onLegalEntityEnd()"
  [menuItems]="menuItems | async"
  (menuClick)="onMenuClick($event)"
  [headerMenuItems]="headerMenuItems | async"
  (headerMenuItemClick)="onHeaderMenuClick($event)"
  [logoutLabel]="'views.header.lbl_logout' | translate"
  (logout)="onLogout()"
  [footerLabel]="isGetCopyright ? (labelCopyright | async) : ('app.footer.copyright' | translate)"
  (footerLabelClick)="onFooterLabelClick()"
  [footerLinks]="footerItems | async"
  (footerLinkClick)="onFooterLinkClick($event)"
  [applyLabel]="'views.sidebar.language.apply' | translate"
  [cancelLabel]="'views.sidebar.language.cancel' | translate"
  [feedback]="isFeedbackEnabled"
  [feedbackLabel]="'views.header.feedbackDialog.feedBackTitle' | translate"
  (feedbackClick)="onFeedbackClick()"
  [mobileLinks]="mobileMenuItems | async"
  (mobileLinkClick)="onMobileLinkClick($event)"
  [chatbox]="chatbot"
  [chatboxLabel]="'Cemex Chatbot'"
  (chatboxClick)="onChatboxClick()"
  [green]="isGreen"
  [appMenu]="appMenu"
  [appMenuLabel]="appMenuLabel"
  [appMenuItems]="appMenuItems"
  (appMenuClick)="onAppMenuClick($event)"
  [needHelpLabel]="'views.global.need_help' | translate"
  [ServiceCenterApp]="ServiceCenterApp"
  [feedBackTitle]="'views.header.feedbackDialog.feedBackTitle' | translate"
  [contactLabel]="'views.header.modal.contactTitle' | translate"
  [notificationsLabel]="'views.header.lbl_notifications' | translate"
  [notificationsLoadingLabel]="'views.notifications.spinner.title.loading' | translate"
  [notificationsDelayLabel]="'views.notifications.spinner.title.delay' | translate"
  [notificationsErrorLabel]="'views.notifications.spinner.title.error' | translate"
  [notificationsErrorLinkRefresh]="
    'views.notifications.spinner.title.error_link_refresh' | translate
  "
  [showUserNotifications]="true"
  [userNotificationLoading]="false"
  [supportContact]="supportContact"
  [disabledProfile]="false"
  [variantHeader]="country === 'IL' ? 'negative' : 'positive'"
  [brandLogo]="country === 'IL' ? 'cemex_logo_readymix_il' : 'cemex_logo'"
  [userCountry]="country"
  [modalLabelApply]="'views.sidebar.language.apply' | translate"
  [modalLabelCancel]="'views.sidebar.language.cancel' | translate"
  [modalLabelChoose]="'views.sidebar.entity-modal.choose' | translate"
  [modalLabelEmptyHeader]="'views.sidebar.entity-modal.empty-header' | translate"
  [modalLabelEmptyMessage]="'views.sidebar.entity-modal.empty-message' | translate"
  [modalLabelFilter]="'views.sidebar.entity-modal.filter' | translate"
  [modalTitle]="'views.global.lbl_legalEntity' | translate"
  [version]="3"
  (isLayoutRendered)="layoutRendered($event)"
  [employeeVariant]="(userType$ | async) !== userTypeEnum.CUSTOMER"
  (entityModalOpen)="entityModalEvent()"
  [myProfileLabel]="'views.header.lbl_myprofile' | translate"
  [chatbotLabel]="'views.header.chatbot-label' | translate"
>
  <div cmx-logo>
    <img
      class="logo {{ country == 'IL' ? 'logo--il' : '' }}"
      src="{{ 'https://www.cemexgo.com/cdn/logos/svg/' + logo }}"
    />
  </div>
  <cmx-alerts-output [modifyZIndex]="entityModalOpen" [name]="mainAlertOutput"></cmx-alerts-output>
  <router-outlet *ngIf="isLayoutRendered && isEntitySelectorRendered"></router-outlet>

  <!-- Cmx Wizeline ChatBot -->
  <cmx-wizeline-chatbot></cmx-wizeline-chatbot>
  <div *ngIf="showChatbot && !chatbotRealocated">
    <cmx-chatbot [relativeSettings]="{ enabled: false }" [languageISO]="languageActiveISO"></cmx-chatbot>
  </div>
  <cwc-modal
    overlayZIndex="99999"
    class="cwc-entity-selector__modal"
    show-close-btn="true"
    templateId="cmx-header-country-support-contact-modal"
    #countrySupportContactModal
  >
    <div slot="header">
      <h1 class="cmx-dialog-title">{{ 'views.header.modal.contactTitle' | translate }}</h1>
    </div>
    <div>
      <div class="cmx-dialog-content">
        <div class="cmx-dialog-content__row">
          <div class="cmx-nav-header__contact-icon-wrapper">
            <cwc-icon
              class="cmx-nav-header__contact-icon hydrated"
              name="e-mail"
              size="76px"
            ></cwc-icon>
          </div>
          <div *ngFor="let email of contactEmails; let i = index">
            <a class="cmx-dialog-content__label" href="mailto:{{ email }}"> {{ email }} </a>
          </div>
        </div>
        <div class="cmx-dialog-content__row">
          <div class="cmx-nav-header__contact-icon-wrapper">
            <cwc-icon
              class="cmx-nav-header__contact-icon hydrated"
              name="phone"
              size="76px"
            ></cwc-icon>
          </div>
          <div *ngFor="let phone of contactPhones; let i = index">
            <a class="cmx-dialog-content__label" href="tel:{{ phone }}"> {{ phone }} </a>
          </div>
        </div>
      </div>
      <div
        class="cmx-dialog-content__row__footer"
        *ngIf="userCountry === 'IL' && contactPhones.length > 0"
      >
        <div id="cmx-header-dialog-schedule">
          <div [dir]="direction ? 'rtl' : 'ltr'" class="cmx-dialog-content__label-support">
            {{ translate.instant('views.header.modal.il.contact') }}
          </div>
          <br />
          <span [dir]="direction ? 'rtl' : 'ltr'" class="cmx-dialog-content__label-support">
            {{ translate.instant('views.header.modal.il.openHours') }}
            {{ translate.instant('views.header.modal.il.schedule') }}
          </span>
          <br />
          <span [dir]="direction ? 'rtl' : 'ltr'" class="cmx-dialog-content__label-support">
            {{ translate.instant('views.header.modal.il.contactService') }}
          </span>
        </div>
      </div>
    </div>
  </cwc-modal>
</cmx-layout-container>
